<app-resp-popup-content>
  <div style="width: 500px; max-width: 100%; position: relative">
    @if (form) {
      <form [formGroup]="form" class=cst-form>
        <fieldset>
          <div class="row">
            <div class="col">
              <frm-text
                i18n-label="@@InfoportalAPI_FacilityFolderFilter_Searchtext"
                label="Searchtext"
                formControlName="searchText"
              ></frm-text>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-infoportal-tags-select
                formControlName="tagIDs"
              ></frm-infoportal-tags-select>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <frm-daterange-picker
                orientation="horizontal"
                [formGroup]="form"
                formControlNameRangeBegin="dateRangeBegin"
                formControlNameRangeEnd="dateRangeEnd"
                >
              </frm-daterange-picker>
            </div>
          </div>
        </fieldset>
      </form>
    }
  </div>
</app-resp-popup-content>
<app-resp-popup-actions>
  <ctrl-btn-accept
    [disabled]="loading || form?.valid !== true"
    (click)="onAccept()"
  ></ctrl-btn-accept>
  <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
</app-resp-popup-actions>
